module.exports = __webpack_public_path__ + "static/media/1-square-occupied.8ae40901.svg";